import Waterfall from '$/components/Waterfall';

export default Waterfall;
export type { WaterfallProps } from '$/components/Waterfall';
